<template>
  <FormContainer withoutDivider>
    <template #title>Informations salarié(e)</template>
    <template #content>
      <!-- Déactiver recherche PRT-640 -->
      <div
        class="form__bloc"
        v-if="!readonly && saisieAdherent && false"
      >
        <RechercheSalarie
          mode="salaries"
          :id-demande="model!.id"
          @selected="onRechercheSalarie"
          class="col-12 col-md-18 col-sm-36"
          :readonly
        />
      </div>

      <div class="form__bloc">
        <WrapperInput
          id="field_44"
          v-model="nomNaissanceModel"
          label="Nom de naissance"
          hint="50 caractères maximum"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_NOM"
          :required="meta.salarie?.nomNaissance?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.nomNaissance?.$messageErreurDirty!"
          :maxlength="50"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_45"
          v-model="nomUsageModel"
          label="Nom d'usage (si différent)"
          hint="50 caractères maximum"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_NOM_NAIS"
          :required="meta.salarie?.nom?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.nom?.$messageErreurDirty!"
          :maxlength="50"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_46"
          v-model="prenomModel"
          label="Prénom (le premier selon l'état civil)"
          hint="50 caractères maximum"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_PRENOM"
          :required="meta.salarie?.prenom?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.prenom?.$messageErreurDirty!"
          :maxlength="50"
          deletable
          :readonly
        />
      </div>
      <div class="form__bloc">
        <WrapperToggleSwitch
          id="field_50"
          v-model="nirTemporaireModel"
          label="Êtes-vous détenteur d'un NIR temporaire ?"
          :required="meta.salarie?.nirTemporaire?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.nirTemporaire?.$messageErreurDirty!"
          :items="OuiOuNon"
          class="col-10 col-md-14 col-sm-36"
          :readonly
          help="Le numéro technique temporaire est un numéro attribué à l'individu par son employeur dans l'attente de la délivrance d'un NIA puis d'un NIR définitif par la sécurité sociale"
        />
        <WrapperInput
          id="field_49"
          v-model="nirModel"
          :label="nirLabel"
          :hint="nirHint"
          class="col-10 col-md-12 col-sm-36"
          placeholder="Ex : 1234567890123"
          :required="meta.salarie?.nir?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.nir?.$messageErreurDirty!"
          :maxlength="nirMaxLength"
          deletable
          :readonly
          :help="nirHelp"
        />
      </div>
      <div class="form__bloc">
        <WrapperDropdown
          id="field_47"
          key="sexe-dropdown"
          v-model="sexeModel"
          label="Sexe"
          class="col-8 col-md-12 col-sm-36"
          :items="sexeItems"
          :readonly
          :required="meta.salarie?.sexe?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.sexe?.$messageErreurDirty!"
        />
        <WrapperInputDate
          id="field_48"
          v-model="dateNaissanceModel"
          label="Date de naissance"
          :hint="HINT_DATE"
          class="col-8 col-md-12 col-sm-36"
          :placeholder="PLACEHOLDER_DATE_NAIS"
          deletable
          :required="meta.salarie?.dateNaissance?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.dateNaissance?.$messageErreurDirty!"
          :readonly
        />

        <WrapperToggleSwitch
          id="field_53"
          v-model="handicapeModel"
          label="Qualité de travailleur handicapé"
          class="col-10 col-md-14 col-sm-36"
          :items="OuiOuNon"
          :required="meta.salarie?.beneficieReconnaissanceTravailleurHandicape?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.beneficieReconnaissanceTravailleurHandicape?.$messageErreurDirty!"
          :readonly
        />
      </div>

      <div class="form__bloc">
        <WrapperDropdown
          id="field_64"
          v-model="cspModel"
          label="Catégorie socio-professionnelle (CSP)"
          class="col-16 col-md-18 col-sm-36"
          :items="lov.Csp"
          :required="meta.salarie?.csp?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.csp?.$messageErreurDirty!"
          key-id="code"
          key-label="intitule"
          :readonly
        />
        <WrapperToggleSwitch
          id="field_54"
          v-model="inscritPoleEmploiModel"
          label="Inscrit à France Travail depuis plus d'un an?"
          class="col-10 col-md-14 col-sm-36"
          :required="meta.salarie?.inscritPoleEmploi?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.inscritPoleEmploi?.$messageErreurDirty!"
          :items="OuiOuNon"
          :readonly
        />
      </div>

      <div class="form__bloc">
        <WrapperDropdown
          id="field_65"
          v-model="situationAvantContratModel"
          label="Situation du salarié"
          :required="meta.salarie?.situation?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.situation?.$messageErreurDirty!"
          class="col-12 col-md-18 col-sm-36"
          :items="lov.Situation"
          :readonly
          key-id="code"
          key-label="intitule"
        />
        <WrapperDropdown
          id="field_66"
          v-model="typeMinimuSocialModel"
          label="Type de minimum social, si bénéficiaire"
          :required="meta.salarie?.typeMinimuSocial?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.typeMinimuSocial?.$messageErreurDirty!"
          class="col-12 col-md-18 col-sm-36"
          :items="lov.TypeMinimumSocial"
          :readonly
          key-id="code"
          key-label="intitule"
        />
        <WrapperDropdown
          id="field_67"
          v-model="diplomePlusEleveModel"
          label="Diplôme ou titre le plus élevé obtenu"
          :required="meta.salarie?.diplomeOuTitreLePlusEleveObtenu?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.diplomeOuTitreLePlusEleveObtenu?.$messageErreurDirty!"
          class="col-12 col-md-18 col-sm-36"
          :items="diplomeItems"
          :readonly
          key-id="code"
          key-label="intitule"
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { computed, inject } from 'vue'
  import { storeToRefs } from 'pinia'
  import {
    FormContainer,
    HINT_DATE,
    PLACEHOLDER_DATE_NAIS,
    PLACEHOLDER_NOM,
    PLACEHOLDER_NOM_NAIS,
    PLACEHOLDER_PRENOM,
  } from '@/features/interface/demande/shared'
  import { useDemandePROAStore } from '../../../../useDemandePROAStore'
  import { PROA_INJECT, type DemandeProAActions } from '../../../../DemandePROA.type'
  import { sexeItems, OuiOuNon, objectIsEmpty } from '@/features/interface/shared/tools'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import { DiplomeOuTitrePlusEleve } from '@/features/domaine/types/opco/Demande/PROA/DiplomeOuTitrePlusEleve'
  import type { SalarieRechercheDTO } from '@/features/api/extranet/dto/Demande/shared/SalarieRechercheDTO'
  import type { DialogResult } from '@/features/interface/dialog/types'
  import { useDialog } from '@/features/interface/dialog/useDialog'
  import { RechercheSalarie } from '@/features/interface/demande/shared/components/salaries'
  import { TypesContextesAutorisesEnum } from '@/features/auth/context-app'

  const store = useDemandePROAStore()
  const { setupFieldWithKey } = store
  const { model, meta, lov, readonly, typeContextCourant } = storeToRefs(store)

  const { patchRemplacerSalarié } = inject<DemandeProAActions>(PROA_INJECT)!
  const saisieAdherent = computed(() => typeContextCourant.value === TypesContextesAutorisesEnum.Adherent)

  const nirMaxLength = computed(() => {
    return model.value?.salarie?.nirTemporaire === true ? 40 : 13
  })

  const nirHint = computed(() => {
    return model.value?.salarie?.nirTemporaire === true ? '11 à 40 caractères' : '13 caractères'
  })

  const nirHelp = computed(() => {
    return model.value?.salarie?.nirTemporaire === true
      ? "Le numéro technique temporaire est un numéro attribué à l'individu par son employeur dans l'attente de la délivrance d'un NIA puis d'un NIR définitif par la sécurité sociale."
      : 'Le numéro de sécurité sociale est inscrit sur la carte vitale, en dessous du nom et du prénom du porteur.'
  })

  const nirLabel = computed(() => {
    return model.value?.salarie?.nirTemporaire === true
      ? 'Numéro technique temporaire'
      : 'Numéro de sécurité sociale (NIR)'
  })

  const nomNaissanceModel = setupFieldWithKey<string>('salarie.nomNaissance', true)
  const nomUsageModel = setupFieldWithKey<string>('salarie.nom', true)
  const prenomModel = setupFieldWithKey<string>('salarie.prenom', true)
  const sexeModel = setupFieldWithKey<string>('salarie.sexe', false)
  const dateNaissanceModel = setupFieldWithKey<string>('salarie.dateNaissance', true)
  const nirTemporaireModel = setupFieldWithKey<boolean>('salarie.nirTemporaire', false)
  // TODO si l'option temporaire (NTT) est cochée, modifier le libellé du NIR par "N° technique temporaire"
  // NIR 13 ou 15, appel api si code commence pas par 3,4,7,8
  // clé de luhne 2 chiffre caractére 14 et 15 facultatif
  // appel api uniquement avec NIR
  // verifier donnée age/departement  etc, par rapport au NIR
  const nirModel = setupFieldWithKey<string>('salarie.nir', true)
  const handicapeModel = setupFieldWithKey<boolean>('salarie.beneficieReconnaissanceTravailleurHandicape', false)

  const cspModel = setupFieldWithKey<string>('salarie.csp', false)
  const inscritPoleEmploiModel = setupFieldWithKey<boolean>('salarie.inscritPoleEmploi', false)
  // const numeroInscriptionPoleEmploiModel = setupFieldWithKey<string>('salarie.numeroInscriptionPoleEmploi', true)
  // const dureeMoisPoleEmploiModel = setupFieldWithKey<string>('salarie.dureeMoisPoleEmploi', true)
  const situationAvantContratModel = setupFieldWithKey<string>('salarie.situation', false)
  const typeMinimuSocialModel = setupFieldWithKey<string>('salarie.typeMinimuSocial', false)
  const diplomePlusEleveModel = setupFieldWithKey<string>('salarie.diplomeOuTitreLePlusEleveObtenu', false)

  const diplomeItems = computed(() =>
    lov.value.Diplome.filter((x) => DiplomeOuTitrePlusEleve.includes(x.code as DiplomeOuTitrePlusEleve)),
  )

  const onRechercheSalarie = async (value: SalarieRechercheDTO) => {
    let reponse: DialogResult = 'Ok'

    if (objectIsEmpty(model.value?.salarie, { exclude: ['source'] }) === false) {
      const dialog = useDialog()
      reponse = await dialog.showDialog({
        message: ['Cette opération entrainera le remplacement de la saisie existante.', "Confirmez-vous l'opération ?"],
        type: 'OkCancel',
        closable: true,
        title: 'Attention',
      })
    }
    if (reponse === 'Ok') {
      patchRemplacerSalarié(value)
    }
  }
</script>
